import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteOverviewChecklistItemFragment = {
  __typename?: 'ChecklistItem';
  id: string;
  title: string;
  action?: string | null;
  subItems: Array<{ __typename?: 'ChecklistSubItem'; id: string; title: string; action?: string | null; completedAt?: any | null }>;
};

export type WebsiteOverviewInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  purpose?: Types.InputMaybe<Types.EventDesignPurpose>;
  eventId: Types.Scalars['ID'];
  skipRsvpDeadline: Types.Scalars['Boolean'];
}>;

export type WebsiteOverviewInfoQuery = {
  __typename?: 'Query';
  rsvpDeadlineSettings?: { __typename?: 'RsvpSettings'; id: string; deadlineEnabled: boolean; deadlineStatus: Types.RsvpDeadlineStatus; effectiveCutoff?: any | null } | null;
  eventByName?: {
    __typename?: 'Event';
    id: string;
    photoV2Url?: string | null;
    photoV2UrlMobile?: string | null;
    hasMobilePhoto: boolean;
    mobilePhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    info: { __typename?: 'EventInfo'; id: string; eventPassword?: string | null };
    productVerticals?: { __typename?: 'EventProductVerticals'; id: string; optOutOfGuestList?: boolean | null } | null;
    pages: Array<{
      __typename?: 'EventPage';
      id: string;
      pageTitle: string;
      disabled: boolean;
      type: Types.EventPageType;
      pageKind: Types.PageKind;
      pageSlug: string;
      visibility: Types.EventPageVisibility;
      private: boolean;
      isPageContainer: boolean;
      photoV2?:
        | {
            __typename?: 'DefaultPagePhoto';
            id: string;
            height: number;
            width: number;
            url: string;
            layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
          }
        | { __typename?: 'Photo'; id: string; height: number; width: number; url: string; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } }
        | null;
      createdAt: { __typename?: 'Date'; timestamp: any };
      photoPresentation?: {
        __typename?: 'WebsitePagePhotoPresentation';
        id: string;
        presentationLayout: string;
        cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; height: number; unit: string; width: number; x: number; y: number } | null;
      } | null;
    }>;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; schemaURL: string; websiteLayout: string; dataJSON: any; id: string } | null;
    } | null;
    pageContainers?: Array<{
      __typename?: 'PageContainer';
      id: string;
      visibility: Types.EventPageVisibility;
      mainPhotoPresentationLayout?: string | null;
      mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue'; x: Types.PhotoXPosition; y: Types.PhotoYPosition } | null;
      mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo'; unit: string; height: number; width: number; x: number; y: number } | null;
    }> | null;
    checklist?: {
      __typename?: 'EventChecklist';
      id: string;
      title: string;
      items: Array<{
        __typename?: 'ChecklistItem';
        id: string;
        title: string;
        action?: string | null;
        subItems: Array<{ __typename?: 'ChecklistSubItem'; id: string; title: string; action?: string | null; completedAt?: any | null }>;
      }>;
    } | null;
  } | null;
};

export type MediaCollectionsQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type MediaCollectionsQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    mediaInfo?: {
      __typename?: 'MediaInfo';
      mediaCount: number;
      maxPhotoCount: number;
      thumbnails?: Array<
        { __typename?: 'MediaPhoto'; id: string; photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number } } | { __typename?: 'MediaVideo' }
      > | null;
    } | null;
    mediaCollections?: Array<{
      __typename?: 'MediaCollection';
      id: string;
      name: string;
      type?: string | null;
      magicTokenPermissions?: Array<Types.MagicTokenPermissions | null> | null;
      mediaCount: number;
      createdAt: { __typename?: 'Date'; dateString: string; timestamp: any };
      mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; displayMode: Types.MediaCollectionDisplayMode; reactionsEnabled?: boolean | null };
      thumbnails?: Array<
        | {
            __typename?: 'MediaPhoto';
            id: string;
            photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number };
            createdAt: { __typename?: 'Date'; dateString: string; timestamp: any };
          }
        | { __typename?: 'MediaVideo' }
      > | null;
    }> | null;
  } | null;
};

export type MediaCollectionByIdQueryVariables = Types.Exact<{
  mediaCollectionById: Types.Scalars['ID'];
}>;

export type MediaCollectionByIdQuery = {
  __typename?: 'Query';
  mediaCollectionById?: {
    __typename?: 'MediaCollection';
    id: string;
    name: string;
    type?: string | null;
    mediaCount: number;
    sortBy: Types.MediaCollectionSortField;
    sortDirection: Types.MediaCollectionSortDirection;
    mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; displayMode: Types.MediaCollectionDisplayMode; reactionsEnabled?: boolean | null };
    media?: Array<
      | {
          __typename?: 'MediaPhoto';
          id: string;
          approvalStatus?: Types.MediaApprovalStatus | null;
          photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number; assetId: string };
        }
      | { __typename?: 'MediaVideo' }
    > | null;
    thumbnails?: Array<
      | {
          __typename?: 'MediaPhoto';
          id: string;
          photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number };
          createdAt: { __typename?: 'Date'; dateString: string; timestamp: any };
        }
      | { __typename?: 'MediaVideo' }
    > | null;
    createdAt: { __typename?: 'Date'; dateString: string; timestamp: any };
  } | null;
};

export type CreateMediaCollectionMutationVariables = Types.Exact<{
  payload: Types.CreateMediaCollectionInput;
}>;

export type CreateMediaCollectionMutation = {
  __typename?: 'Mutation';
  createMediaCollection: {
    __typename?: 'MediaCollection';
    id: string;
    name: string;
    sortBy: Types.MediaCollectionSortField;
    sortDirection: Types.MediaCollectionSortDirection;
    mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; displayMode: Types.MediaCollectionDisplayMode; reactionsEnabled?: boolean | null };
  };
};

export type UpdateMediaCollectionMutationVariables = Types.Exact<{
  payload: Types.UpdateMediaCollectionInput;
}>;

export type UpdateMediaCollectionMutation = {
  __typename?: 'Mutation';
  updateMediaCollection: {
    __typename?: 'MediaCollection';
    id: string;
    name: string;
    sortBy: Types.MediaCollectionSortField;
    sortDirection: Types.MediaCollectionSortDirection;
    mediaCollectionAttributes: { __typename?: 'MediaCollectionAlbumAttribute'; displayMode: Types.MediaCollectionDisplayMode; reactionsEnabled?: boolean | null };
  };
};

export type DeleteMediaCollectionMutationVariables = Types.Exact<{
  deleteMediaCollectionId: Types.Scalars['ID'];
}>;

export type DeleteMediaCollectionMutation = { __typename?: 'Mutation'; deleteMediaCollection?: any | null };

export type CreateMediaPhotoMutationVariables = Types.Exact<{
  payload: Types.createMediaPhotoInput;
}>;

export type CreateMediaPhotoMutation = {
  __typename?: 'Mutation';
  createMediaPhoto?: { __typename?: 'MediaPhoto'; id: string; photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number } } | null;
};

export type AddMediaToCollectionMutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.addMediaToCollectionInput>;
}>;

export type AddMediaToCollectionMutation = {
  __typename?: 'Mutation';
  addMediaToCollection: {
    __typename?: 'MediaCollection';
    id: string;
    name: string;
    media?: Array<
      { __typename?: 'MediaPhoto'; id: string; photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number } } | { __typename?: 'MediaVideo' }
    > | null;
  };
};

export type AddMediaToCollectionV2MutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.addMediaToCollectionInputV2>;
}>;

export type AddMediaToCollectionV2Mutation = {
  __typename?: 'Mutation';
  addMediaToCollectionV2:
    | {
        __typename?: 'addMediaToCollectionResponse';
        success: boolean;
        message: string;
        mediaCollection?: { __typename?: 'MediaCollection'; id: string } | null;
        newMedia?: Array<{ __typename?: 'MediaPhoto'; id: string } | { __typename?: 'MediaVideo' }> | null;
      }
    | {
        __typename?: 'addMediaToCollectionResponseError';
        failedMediaIds?: Array<string> | null;
        success: boolean;
        message: string;
        newMedia?: Array<{ __typename?: 'MediaPhoto'; id: string } | { __typename?: 'MediaVideo' }> | null;
      };
};

export type RemoveMediaFromCollectionMutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.removeMediaFromCollectionInput>;
}>;

export type RemoveMediaFromCollectionMutation = { __typename?: 'Mutation'; removeMediaFromCollection: { __typename?: 'MediaCollection'; id: string; name: string } };

export type DeleteMediaMutationVariables = Types.Exact<{
  mediaId: Types.Scalars['ID'];
}>;

export type DeleteMediaMutation = { __typename?: 'Mutation'; deleteMedia?: any | null };

export type GetMediaCollectionMagicTokenQueryVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type GetMediaCollectionMagicTokenQuery = { __typename?: 'Query'; mediaCollectionMagicToken?: string | null };

export type GetMediaCollectionMagicTokenV2QueryVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type GetMediaCollectionMagicTokenV2Query = {
  __typename?: 'Query';
  mediaCollectionMagicTokenV2?: { __typename?: 'MediaMagicToken'; token: string; permissions?: Array<Types.MagicTokenPermissions> | null; disabled?: boolean | null } | null;
};

export type GenerateMagicTokenForMediaCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type GenerateMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation'; generateMagicTokenForMediaCollection: string };

export type RemoveMagicTokenFromMediaCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type RemoveMagicTokenFromMediaCollectionMutation = { __typename?: 'Mutation'; removeMagicTokenFromMediaCollection?: any | null };

export type DisableMagicTokenForMediaCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type DisableMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation'; disableMagicTokenForMediaCollection?: any | null };

export type EnableMagicTokenForMediaCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type EnableMagicTokenForMediaCollectionMutation = { __typename?: 'Mutation'; enableMagicTokenForMediaCollection?: any | null };

export type SetMediaTokenPermissionsMutationVariables = Types.Exact<{
  payload?: Types.InputMaybe<Types.setMediaTokenPermissionsInput>;
}>;

export type SetMediaTokenPermissionsMutation = { __typename?: 'Mutation'; setMediaTokenPermissions?: any | null };

export type UploadPhotosFromUrlsMutationVariables = Types.Exact<{
  payload: Array<Types.UploadPhotoFromUrlPayload> | Types.UploadPhotoFromUrlPayload;
}>;

export type UploadPhotosFromUrlsMutation = { __typename?: 'Mutation'; uploadPhotosFromUrls: Array<{ __typename?: 'Photo'; id: string } | null> };

export type GetEventMediaQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventMediaQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    media?: Array<
      | {
          __typename?: 'MediaPhoto';
          id: string;
          createdAt: { __typename?: 'Date'; milliseconds: number };
          photo: { __typename?: 'Photo'; id: string; url: string; height: number; width: number; assetId: string; mimeType: string; fileSize?: number | null; deleted: boolean };
        }
      | { __typename?: 'MediaVideo' }
    > | null;
  } | null;
};

export type GetApprovedPhotosQueryVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
  cursor?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type GetApprovedPhotosQuery = {
  __typename?: 'Query';
  getApprovedPhotos: {
    __typename?: 'ApprovedPhotosResult';
    nextCursor?: string | null;
    photos: Array<{ __typename?: 'MediaPhoto'; id: string; approvalStatus?: Types.MediaApprovalStatus | null; photo: { __typename?: 'Photo'; id: string; url: string } }>;
    removed: Array<{ __typename?: 'MediaPhoto'; id: string; approvalStatus?: Types.MediaApprovalStatus | null; photo: { __typename?: 'Photo'; id: string; url: string } }>;
  };
};

export type SetEventPhotoAssetMutationVariables = Types.Exact<{
  setEventAssetId: Types.Scalars['ID'];
  payload: Types.SetAssetPayload;
}>;

export type SetEventPhotoAssetMutation = {
  __typename?: 'Mutation';
  setEventAsset: { __typename?: 'Event'; id: string; photo?: { __typename?: 'Photo'; id: string; url: string } | null };
};

export type SetEventPhotoV2UrlMutationVariables = Types.Exact<{
  payload: Types.SetEventPhotoV2Payload;
}>;

export type SetEventPhotoV2UrlMutation = { __typename?: 'Mutation'; setEventPhotoV2Url: { __typename?: 'Event'; id: string; photoV2Url?: string | null } };

export const WebsiteOverviewChecklistItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteOverviewChecklistItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChecklistItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WebsiteOverviewInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteOverviewInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipRsvpDeadline' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'rsvpDeadlineSettings' },
            name: { kind: 'Name', value: 'getRsvpSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'skip' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'skipRsvpDeadline' } } }],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveCutoff' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2Url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2UrlMobile' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMobilePhoto' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productVerticals' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'optOutOfGuestList' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PageDetails' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageContainers' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainPhotoAlignment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                          ],
                        },
                      },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomPagePhotoPresentationInfo' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checklist' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteOverviewChecklistItem' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteOverviewChecklistItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ChecklistItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subItems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PageDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'private' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomPagePhotoPresentationInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainPhotoCropInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mainPhotoPresentationLayout' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteOverviewInfoQuery__
 *
 * To run a query within a React component, call `useWebsiteOverviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteOverviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteOverviewInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *      eventId: // value for 'eventId'
 *      skipRsvpDeadline: // value for 'skipRsvpDeadline'
 *   },
 * });
 */
export function useWebsiteOverviewInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>(WebsiteOverviewInfoDocument, baseOptions);
}
export function useWebsiteOverviewInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>(WebsiteOverviewInfoDocument, baseOptions);
}
export type WebsiteOverviewInfoQueryHookResult = ReturnType<typeof useWebsiteOverviewInfoQuery>;
export type WebsiteOverviewInfoLazyQueryHookResult = ReturnType<typeof useWebsiteOverviewInfoLazyQuery>;
export type WebsiteOverviewInfoQueryResult = Apollo.QueryResult<WebsiteOverviewInfoQuery, WebsiteOverviewInfoQueryVariables>;
export const MediaCollectionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaCollections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxPhotoCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thumbnails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dateString' },
                              arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'magicTokenPermissions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mediaCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayMode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'thumbnails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'dateString' },
                                          arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMediaCollectionsQuery__
 *
 * To run a query within a React component, call `useMediaCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useMediaCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionsQuery, MediaCollectionsQueryVariables>) {
  return ApolloReactHooks.useQuery<MediaCollectionsQuery, MediaCollectionsQueryVariables>(MediaCollectionsDocument, baseOptions);
}
export function useMediaCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionsQuery, MediaCollectionsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MediaCollectionsQuery, MediaCollectionsQueryVariables>(MediaCollectionsDocument, baseOptions);
}
export type MediaCollectionsQueryHookResult = ReturnType<typeof useMediaCollectionsQuery>;
export type MediaCollectionsLazyQueryHookResult = ReturnType<typeof useMediaCollectionsLazyQuery>;
export type MediaCollectionsQueryResult = Apollo.QueryResult<MediaCollectionsQuery, MediaCollectionsQueryVariables>;
export const MediaCollectionByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaCollectionById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaCollectionById' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaCollectionById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaCollectionById' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mediaCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortDirection' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalStatus' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'thumbnails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dateString' },
                                    arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdAt' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'long' } }],
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMediaCollectionByIdQuery__
 *
 * To run a query within a React component, call `useMediaCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCollectionByIdQuery({
 *   variables: {
 *      mediaCollectionById: // value for 'mediaCollectionById'
 *   },
 * });
 */
export function useMediaCollectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>(MediaCollectionByIdDocument, baseOptions);
}
export function useMediaCollectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>(MediaCollectionByIdDocument, baseOptions);
}
export type MediaCollectionByIdQueryHookResult = ReturnType<typeof useMediaCollectionByIdQuery>;
export type MediaCollectionByIdLazyQueryHookResult = ReturnType<typeof useMediaCollectionByIdLazyQuery>;
export type MediaCollectionByIdQueryResult = Apollo.QueryResult<MediaCollectionByIdQuery, MediaCollectionByIdQueryVariables>;
export const CreateMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMediaCollectionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sortBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortDirection' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateMediaCollectionMutationFn = Apollo.MutationFunction<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>;

/**
 * __useCreateMediaCollectionMutation__
 *
 * To run a mutation, you first call `useCreateMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaCollectionMutation, { data, loading, error }] = useCreateMediaCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>(CreateMediaCollectionDocument, baseOptions);
}
export type CreateMediaCollectionMutationHookResult = ReturnType<typeof useCreateMediaCollectionMutation>;
export type CreateMediaCollectionMutationResult = Apollo.MutationResult<CreateMediaCollectionMutation>;
export type CreateMediaCollectionMutationOptions = Apollo.BaseMutationOptions<CreateMediaCollectionMutation, CreateMediaCollectionMutationVariables>;
export const UpdateMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMediaCollectionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaCollectionAttributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reactionsEnabled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sortBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sortDirection' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateMediaCollectionMutationFn = Apollo.MutationFunction<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>;

/**
 * __useUpdateMediaCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaCollectionMutation, { data, loading, error }] = useUpdateMediaCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>(UpdateMediaCollectionDocument, baseOptions);
}
export type UpdateMediaCollectionMutationHookResult = ReturnType<typeof useUpdateMediaCollectionMutation>;
export type UpdateMediaCollectionMutationResult = Apollo.MutationResult<UpdateMediaCollectionMutation>;
export type UpdateMediaCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMediaCollectionMutation, UpdateMediaCollectionMutationVariables>;
export const DeleteMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteMediaCollectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteMediaCollectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteMediaCollectionMutationFn = Apollo.MutationFunction<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>;

/**
 * __useDeleteMediaCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaCollectionMutation, { data, loading, error }] = useDeleteMediaCollectionMutation({
 *   variables: {
 *      deleteMediaCollectionId: // value for 'deleteMediaCollectionId'
 *   },
 * });
 */
export function useDeleteMediaCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>(DeleteMediaCollectionDocument, baseOptions);
}
export type DeleteMediaCollectionMutationHookResult = ReturnType<typeof useDeleteMediaCollectionMutation>;
export type DeleteMediaCollectionMutationResult = Apollo.MutationResult<DeleteMediaCollectionMutation>;
export type DeleteMediaCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteMediaCollectionMutation, DeleteMediaCollectionMutationVariables>;
export const CreateMediaPhotoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMediaPhoto' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createMediaPhotoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMediaPhoto' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateMediaPhotoMutationFn = Apollo.MutationFunction<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>;

/**
 * __useCreateMediaPhotoMutation__
 *
 * To run a mutation, you first call `useCreateMediaPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaPhotoMutation, { data, loading, error }] = useCreateMediaPhotoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMediaPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>(CreateMediaPhotoDocument, baseOptions);
}
export type CreateMediaPhotoMutationHookResult = ReturnType<typeof useCreateMediaPhotoMutation>;
export type CreateMediaPhotoMutationResult = Apollo.MutationResult<CreateMediaPhotoMutation>;
export type CreateMediaPhotoMutationOptions = Apollo.BaseMutationOptions<CreateMediaPhotoMutation, CreateMediaPhotoMutationVariables>;
export const AddMediaToCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddMediaToCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'addMediaToCollectionInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addMediaToCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddMediaToCollectionMutationFn = Apollo.MutationFunction<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>;

/**
 * __useAddMediaToCollectionMutation__
 *
 * To run a mutation, you first call `useAddMediaToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaToCollectionMutation, { data, loading, error }] = useAddMediaToCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddMediaToCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>) {
  return ApolloReactHooks.useMutation<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>(AddMediaToCollectionDocument, baseOptions);
}
export type AddMediaToCollectionMutationHookResult = ReturnType<typeof useAddMediaToCollectionMutation>;
export type AddMediaToCollectionMutationResult = Apollo.MutationResult<AddMediaToCollectionMutation>;
export type AddMediaToCollectionMutationOptions = Apollo.BaseMutationOptions<AddMediaToCollectionMutation, AddMediaToCollectionMutationVariables>;
export const AddMediaToCollectionV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddMediaToCollectionV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'addMediaToCollectionInputV2' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addMediaToCollectionV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'addMediaToCollectionResponse' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mediaCollection' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'addMediaToCollectionResponseError' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'failedMediaIds' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newMedia' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MutationResponse' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddMediaToCollectionV2MutationFn = Apollo.MutationFunction<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>;

/**
 * __useAddMediaToCollectionV2Mutation__
 *
 * To run a mutation, you first call `useAddMediaToCollectionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMediaToCollectionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMediaToCollectionV2Mutation, { data, loading, error }] = useAddMediaToCollectionV2Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddMediaToCollectionV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>) {
  return ApolloReactHooks.useMutation<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>(AddMediaToCollectionV2Document, baseOptions);
}
export type AddMediaToCollectionV2MutationHookResult = ReturnType<typeof useAddMediaToCollectionV2Mutation>;
export type AddMediaToCollectionV2MutationResult = Apollo.MutationResult<AddMediaToCollectionV2Mutation>;
export type AddMediaToCollectionV2MutationOptions = Apollo.BaseMutationOptions<AddMediaToCollectionV2Mutation, AddMediaToCollectionV2MutationVariables>;
export const RemoveMediaFromCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveMediaFromCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'removeMediaFromCollectionInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeMediaFromCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveMediaFromCollectionMutationFn = Apollo.MutationFunction<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>;

/**
 * __useRemoveMediaFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveMediaFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMediaFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMediaFromCollectionMutation, { data, loading, error }] = useRemoveMediaFromCollectionMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRemoveMediaFromCollectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>(RemoveMediaFromCollectionDocument, baseOptions);
}
export type RemoveMediaFromCollectionMutationHookResult = ReturnType<typeof useRemoveMediaFromCollectionMutation>;
export type RemoveMediaFromCollectionMutationResult = Apollo.MutationResult<RemoveMediaFromCollectionMutation>;
export type RemoveMediaFromCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveMediaFromCollectionMutation, RemoveMediaFromCollectionMutationVariables>;
export const DeleteMediaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMedia' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteMediaMutationFn = Apollo.MutationFunction<DeleteMediaMutation, DeleteMediaMutationVariables>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useDeleteMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMediaMutation, DeleteMediaMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(DeleteMediaDocument, baseOptions);
}
export type DeleteMediaMutationHookResult = ReturnType<typeof useDeleteMediaMutation>;
export type DeleteMediaMutationResult = Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMediaMutation, DeleteMediaMutationVariables>;
export const GetMediaCollectionMagicTokenDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMediaCollectionMagicToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaCollectionMagicToken' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMediaCollectionMagicTokenQuery__
 *
 * To run a query within a React component, call `useGetMediaCollectionMagicTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaCollectionMagicTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaCollectionMagicTokenQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetMediaCollectionMagicTokenQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>(GetMediaCollectionMagicTokenDocument, baseOptions);
}
export function useGetMediaCollectionMagicTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>(GetMediaCollectionMagicTokenDocument, baseOptions);
}
export type GetMediaCollectionMagicTokenQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenQuery>;
export type GetMediaCollectionMagicTokenLazyQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenLazyQuery>;
export type GetMediaCollectionMagicTokenQueryResult = Apollo.QueryResult<GetMediaCollectionMagicTokenQuery, GetMediaCollectionMagicTokenQueryVariables>;
export const GetMediaCollectionMagicTokenV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMediaCollectionMagicTokenV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaCollectionMagicTokenV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMediaCollectionMagicTokenV2Query__
 *
 * To run a query within a React component, call `useGetMediaCollectionMagicTokenV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaCollectionMagicTokenV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaCollectionMagicTokenV2Query({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetMediaCollectionMagicTokenV2Query(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>(GetMediaCollectionMagicTokenV2Document, baseOptions);
}
export function useGetMediaCollectionMagicTokenV2LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>(GetMediaCollectionMagicTokenV2Document, baseOptions);
}
export type GetMediaCollectionMagicTokenV2QueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenV2Query>;
export type GetMediaCollectionMagicTokenV2LazyQueryHookResult = ReturnType<typeof useGetMediaCollectionMagicTokenV2LazyQuery>;
export type GetMediaCollectionMagicTokenV2QueryResult = Apollo.QueryResult<GetMediaCollectionMagicTokenV2Query, GetMediaCollectionMagicTokenV2QueryVariables>;
export const GenerateMagicTokenForMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateMagicTokenForMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateMagicTokenForMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'collectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type GenerateMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<
  GenerateMagicTokenForMediaCollectionMutation,
  GenerateMagicTokenForMediaCollectionMutationVariables
>;

/**
 * __useGenerateMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useGenerateMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMagicTokenForMediaCollectionMutation, { data, loading, error }] = useGenerateMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGenerateMagicTokenForMediaCollectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<GenerateMagicTokenForMediaCollectionMutation, GenerateMagicTokenForMediaCollectionMutationVariables>(
    GenerateMagicTokenForMediaCollectionDocument,
    baseOptions,
  );
}
export type GenerateMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useGenerateMagicTokenForMediaCollectionMutation>;
export type GenerateMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<GenerateMagicTokenForMediaCollectionMutation>;
export type GenerateMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<
  GenerateMagicTokenForMediaCollectionMutation,
  GenerateMagicTokenForMediaCollectionMutationVariables
>;
export const RemoveMagicTokenFromMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveMagicTokenFromMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeMagicTokenFromMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'collectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveMagicTokenFromMediaCollectionMutationFn = Apollo.MutationFunction<
  RemoveMagicTokenFromMediaCollectionMutation,
  RemoveMagicTokenFromMediaCollectionMutationVariables
>;

/**
 * __useRemoveMagicTokenFromMediaCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveMagicTokenFromMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMagicTokenFromMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMagicTokenFromMediaCollectionMutation, { data, loading, error }] = useRemoveMagicTokenFromMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useRemoveMagicTokenFromMediaCollectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<RemoveMagicTokenFromMediaCollectionMutation, RemoveMagicTokenFromMediaCollectionMutationVariables>(
    RemoveMagicTokenFromMediaCollectionDocument,
    baseOptions,
  );
}
export type RemoveMagicTokenFromMediaCollectionMutationHookResult = ReturnType<typeof useRemoveMagicTokenFromMediaCollectionMutation>;
export type RemoveMagicTokenFromMediaCollectionMutationResult = Apollo.MutationResult<RemoveMagicTokenFromMediaCollectionMutation>;
export type RemoveMagicTokenFromMediaCollectionMutationOptions = Apollo.BaseMutationOptions<
  RemoveMagicTokenFromMediaCollectionMutation,
  RemoveMagicTokenFromMediaCollectionMutationVariables
>;
export const DisableMagicTokenForMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisableMagicTokenForMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableMagicTokenForMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'collectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DisableMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<
  DisableMagicTokenForMediaCollectionMutation,
  DisableMagicTokenForMediaCollectionMutationVariables
>;

/**
 * __useDisableMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useDisableMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMagicTokenForMediaCollectionMutation, { data, loading, error }] = useDisableMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDisableMagicTokenForMediaCollectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<DisableMagicTokenForMediaCollectionMutation, DisableMagicTokenForMediaCollectionMutationVariables>(
    DisableMagicTokenForMediaCollectionDocument,
    baseOptions,
  );
}
export type DisableMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useDisableMagicTokenForMediaCollectionMutation>;
export type DisableMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<DisableMagicTokenForMediaCollectionMutation>;
export type DisableMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<
  DisableMagicTokenForMediaCollectionMutation,
  DisableMagicTokenForMediaCollectionMutationVariables
>;
export const EnableMagicTokenForMediaCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EnableMagicTokenForMediaCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enableMagicTokenForMediaCollection' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'collectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type EnableMagicTokenForMediaCollectionMutationFn = Apollo.MutationFunction<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>;

/**
 * __useEnableMagicTokenForMediaCollectionMutation__
 *
 * To run a mutation, you first call `useEnableMagicTokenForMediaCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMagicTokenForMediaCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMagicTokenForMediaCollectionMutation, { data, loading, error }] = useEnableMagicTokenForMediaCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useEnableMagicTokenForMediaCollectionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<EnableMagicTokenForMediaCollectionMutation, EnableMagicTokenForMediaCollectionMutationVariables>(
    EnableMagicTokenForMediaCollectionDocument,
    baseOptions,
  );
}
export type EnableMagicTokenForMediaCollectionMutationHookResult = ReturnType<typeof useEnableMagicTokenForMediaCollectionMutation>;
export type EnableMagicTokenForMediaCollectionMutationResult = Apollo.MutationResult<EnableMagicTokenForMediaCollectionMutation>;
export type EnableMagicTokenForMediaCollectionMutationOptions = Apollo.BaseMutationOptions<
  EnableMagicTokenForMediaCollectionMutation,
  EnableMagicTokenForMediaCollectionMutationVariables
>;
export const SetMediaTokenPermissionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetMediaTokenPermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'setMediaTokenPermissionsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setMediaTokenPermissions' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetMediaTokenPermissionsMutationFn = Apollo.MutationFunction<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>;

/**
 * __useSetMediaTokenPermissionsMutation__
 *
 * To run a mutation, you first call `useSetMediaTokenPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMediaTokenPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMediaTokenPermissionsMutation, { data, loading, error }] = useSetMediaTokenPermissionsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetMediaTokenPermissionsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>(SetMediaTokenPermissionsDocument, baseOptions);
}
export type SetMediaTokenPermissionsMutationHookResult = ReturnType<typeof useSetMediaTokenPermissionsMutation>;
export type SetMediaTokenPermissionsMutationResult = Apollo.MutationResult<SetMediaTokenPermissionsMutation>;
export type SetMediaTokenPermissionsMutationOptions = Apollo.BaseMutationOptions<SetMediaTokenPermissionsMutation, SetMediaTokenPermissionsMutationVariables>;
export const UploadPhotosFromUrlsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadPhotosFromUrls' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadPhotoFromUrlPayload' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadPhotosFromUrls' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UploadPhotosFromUrlsMutationFn = Apollo.MutationFunction<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>;

/**
 * __useUploadPhotosFromUrlsMutation__
 *
 * To run a mutation, you first call `useUploadPhotosFromUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPhotosFromUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPhotosFromUrlsMutation, { data, loading, error }] = useUploadPhotosFromUrlsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUploadPhotosFromUrlsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>) {
  return ApolloReactHooks.useMutation<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>(UploadPhotosFromUrlsDocument, baseOptions);
}
export type UploadPhotosFromUrlsMutationHookResult = ReturnType<typeof useUploadPhotosFromUrlsMutation>;
export type UploadPhotosFromUrlsMutationResult = Apollo.MutationResult<UploadPhotosFromUrlsMutation>;
export type UploadPhotosFromUrlsMutationOptions = Apollo.BaseMutationOptions<UploadPhotosFromUrlsMutation, UploadPhotosFromUrlsMutationVariables>;
export const GetEventMediaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fileSize' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleted' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventMediaQuery__
 *
 * To run a query within a React component, call `useGetEventMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMediaQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
}
export function useGetEventMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventMediaQuery, GetEventMediaQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GetEventMediaDocument, baseOptions);
}
export type GetEventMediaQueryHookResult = ReturnType<typeof useGetEventMediaQuery>;
export type GetEventMediaLazyQueryHookResult = ReturnType<typeof useGetEventMediaLazyQuery>;
export type GetEventMediaQueryResult = Apollo.QueryResult<GetEventMediaQuery, GetEventMediaQueryVariables>;
export const GetApprovedPhotosDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetApprovedPhotos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getApprovedPhotos' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'collectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'collectionId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'cursor' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalStatus' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'removed' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'approvalStatus' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetApprovedPhotosQuery__
 *
 * To run a query within a React component, call `useGetApprovedPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedPhotosQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetApprovedPhotosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApprovedPhotosQuery, GetApprovedPhotosQueryVariables>) {
  return ApolloReactHooks.useQuery<GetApprovedPhotosQuery, GetApprovedPhotosQueryVariables>(GetApprovedPhotosDocument, baseOptions);
}
export function useGetApprovedPhotosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApprovedPhotosQuery, GetApprovedPhotosQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetApprovedPhotosQuery, GetApprovedPhotosQueryVariables>(GetApprovedPhotosDocument, baseOptions);
}
export type GetApprovedPhotosQueryHookResult = ReturnType<typeof useGetApprovedPhotosQuery>;
export type GetApprovedPhotosLazyQueryHookResult = ReturnType<typeof useGetApprovedPhotosLazyQuery>;
export type GetApprovedPhotosQueryResult = Apollo.QueryResult<GetApprovedPhotosQuery, GetApprovedPhotosQueryVariables>;
export const SetEventPhotoAssetDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetEventPhotoAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetAssetPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventAsset' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetEventPhotoAssetMutationFn = Apollo.MutationFunction<SetEventPhotoAssetMutation, SetEventPhotoAssetMutationVariables>;

/**
 * __useSetEventPhotoAssetMutation__
 *
 * To run a mutation, you first call `useSetEventPhotoAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPhotoAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPhotoAssetMutation, { data, loading, error }] = useSetEventPhotoAssetMutation({
 *   variables: {
 *      setEventAssetId: // value for 'setEventAssetId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPhotoAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPhotoAssetMutation, SetEventPhotoAssetMutationVariables>) {
  return ApolloReactHooks.useMutation<SetEventPhotoAssetMutation, SetEventPhotoAssetMutationVariables>(SetEventPhotoAssetDocument, baseOptions);
}
export type SetEventPhotoAssetMutationHookResult = ReturnType<typeof useSetEventPhotoAssetMutation>;
export type SetEventPhotoAssetMutationResult = Apollo.MutationResult<SetEventPhotoAssetMutation>;
export type SetEventPhotoAssetMutationOptions = Apollo.BaseMutationOptions<SetEventPhotoAssetMutation, SetEventPhotoAssetMutationVariables>;
export const SetEventPhotoV2UrlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetEventPhotoV2Url' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetEventPhotoV2Payload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventPhotoV2Url' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2Url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetEventPhotoV2UrlMutationFn = Apollo.MutationFunction<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>;

/**
 * __useSetEventPhotoV2UrlMutation__
 *
 * To run a mutation, you first call `useSetEventPhotoV2UrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPhotoV2UrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPhotoV2UrlMutation, { data, loading, error }] = useSetEventPhotoV2UrlMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPhotoV2UrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>) {
  return ApolloReactHooks.useMutation<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>(SetEventPhotoV2UrlDocument, baseOptions);
}
export type SetEventPhotoV2UrlMutationHookResult = ReturnType<typeof useSetEventPhotoV2UrlMutation>;
export type SetEventPhotoV2UrlMutationResult = Apollo.MutationResult<SetEventPhotoV2UrlMutation>;
export type SetEventPhotoV2UrlMutationOptions = Apollo.BaseMutationOptions<SetEventPhotoV2UrlMutation, SetEventPhotoV2UrlMutationVariables>;
